import { cookieManager } from '../Constant/Utils';

export function getStoredAuth0User() {
  const raw = localStorage.getItem('auth0-user');
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getArtistSession(auth0User, user) {
  const storedUser = getStoredAuth0User();
  const email = auth0User?.email || user?.email || storedUser?.email || '';
  const userId =
    auth0User?.userId || auth0User?.sub || storedUser?.sub || user?.userId || '';
  const isLoggedIn = Boolean(email || userId || localStorage.getItem('access_token'));

  return { email, userId, isLoggedIn };
}

export function getArtistAuthHeaders() {
  const sessionToken = localStorage.getItem('access_token');
  if (sessionToken) {
    return { authorization: sessionToken };
  }

  const cookieToken = cookieManager.getCookie('token');
  return cookieToken ? { authorization: cookieToken } : {};
}

export function withCampaignIdentity(data, session) {
  return {
    ...data,
    artist_email: session.email || data?.artist_email || '',
    userId: session.userId || data?.userId || '',
  };
}
